var _circle, _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderShow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 220,
    viewBox: "0 0 220 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 110,
    r: 110,
    fill: "#E6F1FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5261_46854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53 46C53 43.7909 54.7909 42 57 42H163C165.209 42 167 43.7909 167 46V174C167 176.209 165.209 178 163 178H57C54.7909 178 53 176.209 53 174V46Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 104,
    width: 13,
    height: 13,
    rx: 4,
    fill: "#E3E6EA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 126,
    width: 13,
    height: 13,
    rx: 4,
    fill: "#E3E6EA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 148,
    width: 13,
    height: 13,
    rx: 4,
    fill: "#E3E6EA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 108,
    width: 57,
    height: 5,
    rx: 2.5,
    fill: "#E3E6EA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 130,
    width: 57,
    height: 5,
    rx: 2.5,
    fill: "#E3E6EA"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 152,
    width: 39,
    height: 5,
    rx: 2.5,
    fill: "#E3E6EA"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 67,
    width: 44,
    height: 5,
    rx: 2.5,
    fill: "#E3E6EA"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 78,
    width: 26,
    height: 5,
    rx: 2.5,
    fill: "#E3E6EA"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5261_46854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83 89C91.2843 89 98 82.2843 98 74C98 65.7157 91.2843 59 83 59C74.7157 59 68 65.7157 68 74C68 82.2843 74.7157 89 83 89Z",
    fill: "#C7DDF7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.0006 65.6522C80.1243 65.6522 77.7832 67.9925 77.7832 70.8696C77.7832 73.7466 80.1243 76.087 83.0006 76.087C85.8769 76.087 88.218 73.7466 88.218 70.8696C88.218 67.9925 85.8769 65.6522 83.0006 65.6522Z",
    fill: "#0070CD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.6085 77.913H80.392C78.2306 77.913 76.4785 79.6596 76.4785 81.8282V87.5113C78.4506 88.4649 80.6629 89 83.0003 89C85.3376 89 87.5499 88.4649 89.522 87.5113V81.8282C89.522 79.6659 87.7764 77.913 85.6085 77.913Z",
    fill: "#0070CD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5261_46854",
    x: 37,
    y: 30,
    width: 146,
    height: 168,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.722656 0 0 0 0 0.821815 0 0 0 0 0.9375 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5261_46854"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5261_46854",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5261_46854"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(68 59)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderShow);
export default __webpack_public_path__ + "static/media/order-show.637e4a807fb3eb91503fe975eebf5805.svg";
export { ForwardRef as ReactComponent };